import { render, staticRenderFns } from "./AlbumLibrary.vue?vue&type=template&id=299009fa&scoped=true"
import script from "./AlbumLibrary.vue?vue&type=script&lang=js"
export * from "./AlbumLibrary.vue?vue&type=script&lang=js"
import style0 from "./AlbumLibrary.vue?vue&type=style&index=0&id=299009fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299009fa",
  null
  
)

export default component.exports